import { render, staticRenderFns } from "./SupremeCourtAdditionalDetails.vue?vue&type=template&id=490673e5"
import script from "./SupremeCourtAdditionalDetails.vue?vue&type=script&lang=js"
export * from "./SupremeCourtAdditionalDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports